export const handleCard = (brand: string) => {
  switch (brand) {
    case "visa":
      return "Visa";

    case "mastercard":
      return "Mastercard";

    case "hipercard":
      return "Hipercard";

    case "jcb":
      return "JCB";

    case "elo":
      return "Elo";

    case "amex":
      return "American Express";

    case "aura":
      return "Aura";

    case "diners":
      return "Diners Club";

    case "discover":
      return "Discover";

    case "unknown":
      return "Terminado em";

    default:
      return "Cartão indefinido";
  }
};
